<template>

    <div>
      <div class="dash-heading">Ticket Summary</div>

      <good-table
        :cols="cols"
        :rows="list"
        :row-style="cellClass"
      />
      <br />
    </div>

</template>


<script>

import SiteMixins from '@/mixins/SiteMixins'

export default {
  mixins: [SiteMixins],

  methods: {

    successReport (data) {
      this.list = data
    },



    cellClass (row) {
      let pc = ['Closed', 'KIV', 'Completed']
      let prc = ['Critical', 'Urgent']
      let sta = ['Open', 'In Progress']
//      let st = ['Open', 'In Progress']

      if (pc.includes(row.status)) {
        return 'bg-success-lighten-1'
      }

      if (prc.includes(row.priority)) {
        return 'bg-danger-lighten-1'
      }

      if (sta.includes(row.status)) {
        return 'bg-primary-lighten-1'
      }

    },

    format (date) {
      return this.formatDate(date)
    },

  },



  data () {

    return {
      list: null,

      cols: [
        {
          label: 'Category',
          field: 'category',
        },
        {
          label: 'Priority',
          field: 'priority',
        },
        {
          label: 'Status',
          field: 'status',
          tdClass: 'hidden-sm-and-down',
          thClass: 'hidden-sm-and-down',
        },
        {
          label: '# Sites',
          field: 'sites',
          tdClass: 'hidden-md-and-down',
          thClass: 'hidden-md-and-down'
        },
        {
          label: 'Days',
          field: 'days',
        },
        {
          label: 'Opened',
          field: 'opened',
          tdClass: 'hidden-md-and-down',
          thClass: 'hidden-md-and-down',
          formatFn: this.format
        },
        {
          label: 'Target',
          field: 'target',
          tdClass: 'hidden-sm-and-down',
          thClass: 'hidden-sm-and-down',
          formatFn: this.format
        },
        {
          label: 'Closed',
          field: 'completedDate',
          tdClass: 'hidden-sm-and-down',
          thClass: 'hidden-sm-and-down',
          formatFn: this.format
        },
      ]
    }

  },


  created () {
    this.fetchData('/report/tickets/summary' + (this.org().id && !this.isTowerCo() ? '/' + this.org().id : ''), this.successReport, 'Ticket Heatmap Report')
  }

}
</script>



// WEBPACK FOOTER //
// TicketSummary.vue?6906491e